import { promosFailure, promosRequest, promosSuccess } from './actions';
import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { mapPromoOffersSelection } from '../../mappers';
import { IPromoQuerySchema } from '../../repositories/search-offers/entities/query_for_offer_promos/PromoQuerySchema';
import { fetchPromoOffersSafe } from '../../services/fetchPromoOffers/fetchPromoOffersSafe';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TThunkAction } from '../../types/redux/thunk';
import { trackNewPageAction } from '../analytics';
import { setError } from '../error';
import { setPromoOffers } from '../promoOffers';

interface IParameters {
  path?: string;
  jsonQuery?: IJsonQuery;
}

export const promosRequestByParamsAction =
  (parameters: IParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { logger, httpApi, custom } = context;

    const subdomain = custom.subdomain;

    try {
      dispatch(promosRequest());

      const searchPromise = resolveSearchPromosPage({
        httpApi,
        logger,
        subdomain,
        path: parameters?.path,
        jsonQuery: parameters?.jsonQuery,
      });

      const promoOffersPromise = await fetchPromoOffersSafe(context, {
        query: parameters?.jsonQuery as IPromoQuerySchema,
        subdomain,
      });

      const [data, promoOffersResponse] = await Promise.all([searchPromise, promoOffersPromise]);

      dispatch(promosSuccess(data));
      dispatch(setPromoOffers(mapPromoOffersSelection({ config: context.config, promoOffersResponse })));
      dispatch(trackNewPageAction());
    } catch (e) {
      dispatch(promosFailure());

      dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));
    }
  };
